import { render } from "./ModalAddDataPrintTemplate.vue?vue&type=template&id=ae44c316"
import script from "./ModalAddDataPrintTemplate.vue?vue&type=script&lang=js"
export * from "./ModalAddDataPrintTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__